import { render } from "./Helps.vue?vue&type=template&id=29c2e75e"
import script from "./Helps.vue?vue&type=script&lang=js"
export * from "./Helps.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__